import React from 'react'

const defaultInputClass = 'ncss-input pt2-sm pr4-sm pb2-sm pl4-sm'
const defaultTextAreaClass = 'ncss-textarea p4-sm'

const Input = ({textArea, ...props}) => {
  let onChange
  if (props.onChange) {
    onChange = (e) => props.onChange(e.target.value)
  }
  if (props.type === 'textarea' || textArea) {
    return <textarea className={props.className || defaultTextAreaClass} {...props} onChange={onChange} />
  }

  return <input className={props.className || defaultInputClass} {...props} onChange={onChange} />
}

export default Input



// WEBPACK FOOTER //
// ./client/src/components/ncss/TextInput.js